import { render } from "./EmptyPage.vue?vue&type=template&id=fb60f678&scoped=true"
const script = {}

import "./EmptyPage.vue?vue&type=style&index=0&id=fb60f678&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb60f678"]])

export default __exports__